import React, { useEffect, useState } from 'react';

import { getUserLogged } from '../../services/loginClient';
import * as apiClient from "../../services/apiClient";

import './Header.css';

const UserInfoDropdown = () => {
    const [userLogged, setUserLogged] = useState(getUserLogged());
    const [dropdownState, setDropdownState] = useState(false);
    const [translations, setTranslations] = useState([]);

    useEffect(() => {
        const LoadPage = async () => {
            const language = navigator.language.startsWith('es') ? 'es' : 'en';
            const labels = await apiClient.GetLabelsByLabelName(language, "header");

            const data = await apiClient.GetTranslationsByLabels(language, labels);
            setTranslations(data);
        };

        LoadPage();
    }, []);

    const getTranslation = (label) => {
        const translation = translations.find((t) => t.label === label);
        return translation ? translation.body : '';
    };

    const handleDropdownClick = () => {
        setDropdownState(!dropdownState);
    };

    return (
        <li className="nav-item dropdown">
            {/* Modificación: Se eliminó el icono de la campana */}
            <a className="nav-link d-flex align-items-center hoverable button-like" data-toggle="dropdown" href="#">
                <img src={`data:image/jpeg;base64,${userLogged.photo}`} className="img-circle elevation-2 user-image" alt="User Image" />
                <span className="ml-2">{userLogged.displayName}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                <a href="/Logout" className="dropdown-item">
                    <i className="fas fa-sign-out-alt mr-2"></i> {getTranslation('header.logout')}
                </a>
            </div>
        </li>
    );
};

const Header = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [userlogged, setUserlogged] = useState(getUserLogged());

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    handleSidebarToggle(document.body.classList.contains('sidebar-collapse'));
                }
            });
        });

        observer.observe(document.body, { attributes: true });
        return () => {
            observer.disconnect();
        };
    }, []);

    const handleSidebarToggle = (collapsed) => {
        setIsSidebarCollapsed(collapsed);
    };

    return (
        <div>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light header-background">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <img
                            id='menu_open'
                            className={`menu_open ${isSidebarCollapsed ? 'rotate-expanded' : 'rotate-collapsed'}`}
                            data-widget="pushmenu"
                            role="button"
                            alt="menu_open"
                            src="dist/img/menu_open.png"
                            href="#"
                        />
                    </li>
                    <li className="nav-item d-none d-sm-inline-block">
                        <a href="/" className="nav-link ayesa-permisos-link">
                            AYESA ENG TIMESHEET
                        </a>
                    </li>
                </ul>
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    {/* Navbar Search */}
                    {/* Messages Dropdown Menu */}
                    {/* Notifications Dropdown Menu */}
                    <UserInfoDropdown />
                    <li className="nav-item">
                        {/*<a className="nav-link" data-widget="fullscreen" href="#" role="button">*/}
                        {/*    <i className="fas fa-expand-arrows-alt" />*/}
                        {/*</a>*/}
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Header;